<template>
  <a-drawer width="35%" placement="right" :closable="false" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>购买详情</b>
    </a-divider>
    <a-descriptions title="购买信息" layout="vertical" bordered>
      <a-descriptions-item label="用户昵称">
        {{ form.nickname || '-' }}
      </a-descriptions-item>
      <a-descriptions-item label="短剧名称">
        {{ form.videoName || '-' }}
      </a-descriptions-item>
      <a-descriptions-item label="订单号">
        {{ form.orderNo || '-' }}
      </a-descriptions-item>
      <a-descriptions-item label="剧集">
        {{ form.serialNumber || '-' }}
      </a-descriptions-item>
      <a-descriptions-item label="购买类型">
        <span v-if="form.type === 0">免费</span>
        <span v-else-if="form.type === 1">金币</span>
        <span v-else-if="form.type === 2">金币</span>
        <span v-else-if="form.type === 3">观看广告</span>
        <span v-else>-</span>
      </a-descriptions-item>
      <a-descriptions-item label="花费金额">
        {{ form.price || '-' }}
      </a-descriptions-item>
      <a-descriptions-item label="创建时间">
        {{ parseTime(form.createTime) || '-' }}
      </a-descriptions-item>
      <a-descriptions-item label="备注" span="2" v-if="form.remark">
        {{ form.remark }}
      </a-descriptions-item>
    </a-descriptions>
    <div class="bottom-control" style="margin-top: 20px; text-align: right;">
      <a-button type="primary" @click="onClose">关闭</a-button>
    </div>
  </a-drawer>
</template>

<script>
export default {
  name: 'DetailForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      open: false,
      form: {}
    }
  },
  methods: {
    onClose () {
      this.open = false
      this.form = {}
    },
    /** 显示详情 */
    handleDetail (row) {
      if (!row) {
        this.$message.warning('数据不存在')
        return
      }
      // 直接使用传入的数据，不调用接口
      this.form = { ...row }
      this.open = true
    }
  }
}
</script>

<style scoped lang="less">
.bottom-control {
  margin-top: 20px;
  text-align: right;
}
</style>

